
export { default as Head } from "./DocumentHead"